module.exports = __webpack_public_path__ + "img/mtp_kakemono.8a28025d.jpg";